import Vod from "./instapro/vod"
import { fetchGames } from "@/api/pgResources"
import {
  getAllInstaproGames,
  getAvailableGames,
} from "../../api/services/instapro"
import {fetchCoachUsers} from "@/store/coaching/coaching.apis";
import {COACH_SEARCH_FILTERS} from "@/store/coaching/coaching.constants";

const state = {
  instaproGames: [],
  allInstaproGames: {}, // including unavailable ones
}
const getters = {
  instaproGames: state => state.instaproGames,
  allInstaproGames: state => state.allInstaproGames,
}
const mutations = {
  setInstaproGames: (state, games) => (state.instaproGames = games),
  setAllInstaproGames: (state, games) => (state.allInstaproGames = games),
}
const actions = {
  async loadInstaproGames ({ commit, state }) {
    if (state.instaproGames && state.instaproGames.length) {
      return
    }

    try {
      let gamesList = []
      let page = 0
      let nextPageUrl = null
      do {
        const gamesData = await getAvailableGames({
          page: ++page,
        })
        const games = gamesData?.result?.data || []
        gamesList.push(...games)
        nextPageUrl = gamesData?.result?.next_page_url || null
      } while (nextPageUrl !== null)

      commit("setInstaproGames", gamesList)
    } catch (e) {
      console.error("Failed to load InstaPro games", e)
    }
  },
  async loadAllInstaproGames ({ commit, state }) {
    if (Object.keys(state.allInstaproGames).length > 0) {
      return
    }
    const proGames = await fetchGames()
    let instaproGames = await getAllInstaproGames()
    const gameOrders = {}
    proGames.forEach((pgGame, index) => (gameOrders[pgGame.key] = index))
    instaproGames = instaproGames
      .map(game => ({
        ...game,
        order: gameOrders[game.name],
      }))
      .filter(game => game.order !== undefined)
      .sort((game1, game2) => game1.order - game2.order)

    let allInstaproGames = {}
    instaproGames.forEach(game => {
      const gameKey = game.name
      allInstaproGames[gameKey] = game
    })

    commit("setAllInstaproGames", allInstaproGames)
  },
  async openInstaproWidget ({ dispatch }) {
    await dispatch("Optimizely/trackEvent", "open instapro widget", {
      root: true,
    })
    const openInstaproWidget = new CustomEvent("openInstacoachDrawer")
    document.dispatchEvent(openInstaproWidget)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    Vod,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/instapro.js